import axios from 'axios'

function join (arr) {
  const separator = arguments.length > 1 ? arguments[1] : ', '
  return arr.filter(function (n) {
    return n
  }).join(separator)
}

function formatAddress (address) {
  return join([
    join([address.settlement_type, address.settlement], ' '),
    ((address.city !== address.region && join([address.city_type, address.city], ' ')) || ''),
    join([address.region_type, address.region], ' '),
    join([address.country], ' ')
  ])
}

function markQueryInStr (str, query) {
  const strLow = str.toLowerCase()
  const rex = new RegExp(query.toLowerCase(), 'g')
  const points = []

  let match
  while ((match = rex.exec(strLow)) !== null) {
    const i = match.index
    if (str[i] === str[i].toUpperCase()) {
      points[0] = i
      points[1] = i + query.length
      break
    }
  }

  if (points.length) {
    return str.slice(0, points[0]) + '<b>' + str.slice(points[0], points[1]) + '</b>' + str.slice(points[1])
  }
  return str
}

function getAddresses ({ searchQuery }) {
  const data = JSON.stringify({
    query: searchQuery,
    count: 5,
    locations: [{
      country: '*'
    }]
  })
  return axios({
    method: 'post',
    url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token 6fad06a72067d00fca8b29fc3f0094579ec47b66'
    },
    data: data
  })
}

function getCities ({ searchQuery, callback }) {
  const data = JSON.stringify({
    query: searchQuery,
    count: 5,
    locations: [{
      country: '*'
    }],
    from_bound: { value: 'city' },
    to_bound: { value: 'city' }
  })
  axios({
    method: 'post',
    url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token 6fad06a72067d00fca8b29fc3f0094579ec47b66'
    },
    data: data
  })
    .then(response => {
      const options = response.data.suggestions.map((suggest, i) => {
        const data = suggest.data
        let label = formatAddress(data)
        label = markQueryInStr(label, searchQuery.trim())
        return {
          id: data.country_iso_code + '_' + (data.region_iso_code || '') + '_' + data.city,
          name: label,
          customLabel: data.city,
          val: {
            city: data.city,
            countryCode: data.country_iso_code,
            cityFiasId: data.city_fias_id || null
          }
        }
      })
      callback(null, options)
    })
}

function getCurrentLocation () {
  return axios({
    method: 'get',
    url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token 6fad06a72067d00fca8b29fc3f0094579ec47b66'
    }
  })
}

export {
  getCities,
  getCurrentLocation,
  markQueryInStr,
  getAddresses
}
